var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-bread-crumbs"},[_vm._l((_vm.routes),function(route,kroute){return _c('div',{key:kroute,staticClass:"bread-item"},[_c('router-link',{attrs:{"to":route}},[_c('small',[_vm._v(_vm._s(route.title))])])],1)}),_c('div',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }